import { createIcon } from '../../createIcon';
import { withIcon } from '../../withIcon';
import { StopSvg } from './Stop';

export const StopIcon = createIcon('stop', StopSvg);
/**
 * @deprecated используйте StopIcon
 */
export const withStopIcon = withIcon('stop', StopSvg);
